import { challengeHistory } from '../data/challengeData';

export function getCurrentStreak() {
	let streak = 0;

	for (let i = 0; i < challengeHistory.length; i += 1) {
		const result = challengeHistory[i].result;

		if (result === 'won') {
			streak += 1;
		} else if (result === 'lost') {
			break;
		}
	}

	return streak;
}

export function getStreakFromHistory(history) {
	let streak = 0;

	for (let i = 0; i < history.length; i += 1) {
		const result = history[i].result;

		if (result === 'won') {
			streak += 1;
		} else if (result === 'lost') {
			break;
		}
	}

	return streak;
}

export function getLossStreakFromHistory(history) {
	let streak = 0;

	for (let i = 0; i < history.length; i += 1) {
		const result = history[i].result;

		if (result === 'lost') {
			streak += 1;
		} else if (result === 'won') {
			break;
		}
	}

	return streak;
}
